// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__Ze-PR","select":"Header_select__6TLTN","clinic":"Header_clinic__1pexs"};